exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.all-notify {\n  top: 25px !important;\n}\n", ""]);

// exports
